<template>
  <div @click="isInfoOpen = !isInfoOpen" :class="$style.container">
    <div :class="$style.date">
      {{ lead.created_at.substr(0, 10).split("-").reverse().join(".") }}
    </div>
    <div :class="$style.content">
      <div :class="$style.column">{{ lead.name }}</div>
      <div :class="$style.column">{{ getType() }}</div>
      <div :class="$style.column">
        <div :class="[$style.dot, $style[getStatus().color]]"></div>
        {{ getStatus().title }}
      </div>
      <div :class="$style.column">
        <img :src="getChannel().icon" alt="" />
        {{ getChannel().title }}
      </div>
      <div :class="[$style.column, { [$style.empty]: !lead.payment_type }]">
        {{ getPayment() }}
      </div>
      <div
        :class="[$style.column, { [$style.empty]: !lead.lead_qualification }]"
      >
        {{ getLead() }}
      </div>
      <div
        :class="[
          $style.column,
          {
            [$style.empty]:
              lead.estimated_time === '00:00' || lead.estimated_cost === '0.00',
          },
        ]"
      >
        {{ lead.estimated_time.split(".").join(":") }} h /
        {{ lead.estimated_cost }} $
      </div>
    </div>
    <div :class="$style.edit">
      <img
        v-if="!isSettingsOpen"
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/ellipsis.svg"
        alt=""
      />
      <img
        v-else
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/medium-cross.svg"
        alt=""
      />
      <div v-if="isSettingsOpen" :class="$style.settings">
        <div @click.stop="edit">
          <img src="/icons/edit-black.svg" alt="" />Редактировать завку
        </div>
        <div @click.stop="remove" :class="$style.red">
          <img src="/icons/delete.svg" alt="" />Удалить завку
        </div>
      </div>
    </div>
  </div>
  <Transition>
    <LeadInfo v-if="isInfoOpen" :lead="lead" />
  </Transition>
</template>

<script>
import FILTERS from "@/assets/constants/filters.json";
import LeadInfo from "./LeadInfo.vue";
export default {
  data() {
    return {
      types: FILTERS.types,
      statuses: FILTERS.statuses,
      channels: FILTERS.channels,
      payments: FILTERS.payments,
      leads: FILTERS.leads,
      isInfoOpen: false,
      isSettingsOpen: false,
    };
  },
  props: {
    lead: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    LeadInfo,
  },
  methods: {
    getChannel() {
      return this.lead.attraction_channel
        ? this.channels.find((i) => i.slug === this.lead.attraction_channel)
        : "";
    },
    getStatus() {
      return this.lead.project_status
        ? this.statuses.find((i) => i.slug === this.lead.project_status)
        : "";
    },
    getPayment() {
      return this.lead.payment_type
        ? this.payments.find((i) => i.slug === this.lead.payment_type).title
        : "";
    },
    getType() {
      return this.lead.project_type
        ? this.types.find((i) => i.slug === this.lead.project_type).title
        : "";
    },
    getLead() {
      return this.lead.lead_qualification
        ? this.leads.find((i) => i.slug === this.lead.lead_qualification).title
        : "";
    },
    async remove() {
      await this.$store.dispatch("deleteLead", this.lead.id);
      await this.$store.dispatch("getLeads", {});
    },
    edit() {
      this.$router.push(`/lead/${this.lead.id}`);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: $bg-secondary;
  padding: 1.5rem;
  border-bottom: 1px solid $bg-separator;
  @include Body1;
  .date {
    flex: 0 0 5rem;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    .column {
      min-width: 9.5rem;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      &:last-child {
        min-width: none;
        width: 9.5rem;
      }
      &.empty {
        color: $red;
      }
      .dot {
        width: 0.5rem;
        height: 0.5rem;
        flex: 0 0 0.5rem;
        border-radius: 50%;
        &.orange {
          background-color: $orange;
        }
        &.grey {
          background-color: $t-secondary;
        }
        &.green {
          background-color: $main-green;
        }
        &.purple {
          background-color: $purple;
        }
        &.blue {
          background-color: $blue-primary;
        }
        &.red {
          background-color: $red-primary;
        }
      }
    }
  }

  .edit {
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    .settings {
      width: 15rem;
      position: absolute;
      top: 0;
      right: 2.5rem;
      background-color: $bg-secondary;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      div {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        @include Subtitle;
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-bottom: 1px solid $bg-separator;
        &.red {
          color: $red;
          border-bottom: none;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
  max-height: 3000px;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
